module.exports = __webpack_public_path__ + "img/free_discussion.7977659b.jpg";